module.exports = __webpack_public_path__ + "img/GENERAL-CIAZ-2.03e6c00a.jpg";